import React, { useEffect, useState } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('logo'); // logo | expand | done

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('expand'), 1800);
    const t2 = setTimeout(() => {
      setPhase('done');
      if (onComplete) onComplete();
    }, 2600);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onComplete]);

  if (phase === 'done') return null;

  return (
    <div className={`splash ${phase === 'expand' ? 'splash--exit' : ''}`}>
      <div className="splash__content">
        {/* Animated logo mark */}
        <div className="splash__logo-mark">
          <svg viewBox="0 0 60 60" className="splash__svg">
            <defs>
              <linearGradient id="splashGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#00F2FF" />
                <stop offset="100%" stopColor="#C9A84C" />
              </linearGradient>
              <linearGradient id="splashYaz" x1="30" y1="48" x2="30" y2="8"
                gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#C9A84C" />
                <stop offset="100%" stopColor="#E8D5A3" />
              </linearGradient>
              <filter id="splashGlow" x="-40%" y="-40%" width="180%" height="180%">
                <feGaussianBlur stdDeviation="1.5" result="b" />
                <feMerge>
                  <feMergeNode in="b" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>

            {/* Outer orbital ring */}
            <circle
              className="splash__ring splash__ring--outer"
              cx="30" cy="30" r="28"
              fill="none"
              stroke="url(#splashGrad)"
              strokeWidth="1"
            />

            {/* ⵣ (Yaz) */}
            <text
              className="splash__yaz splash__yaz-text"
              x="30"
              y="34"
              textAnchor="middle"
              dominantBaseline="middle"
              fill="url(#splashYaz)"
            >
              ⵣ
            </text>

            {/* 5-pointed star at apex */}
            <polygon
              className="splash__star"
              points="30,3 31.2,6.5 35,6.7 32,8.5 33,12 30,10 27,12 28,8.5 25,6.7 28.8,6.5"
              fill="#F0E4C0"
              filter="url(#splashGlow)"
            />
          </svg>
        </div>

        {/* Text */}
        <div className="splash__text">
          <span className="splash__letter splash__letter--m">M</span>
          <span className="splash__letter splash__letter--a">A</span>
          <span className="splash__letter splash__letter--i">I</span>
        </div>

        {/* Loading bar */}
        <div className="splash__loader-bar">
          <div className="splash__loader-fill"></div>
        </div>
      </div>

      {/* Background particles */}
      <div className="splash__particles">
        <span></span><span></span><span></span><span></span>
      </div>
    </div>
  );
};

export default SplashScreen;
